import { assessmentSummaryConstants } from '../../_constants';

const initialState = { AssessmentReportLoading: true, data: '', error: false };

export function getAssessmentReport(state = initialState, action) {
    
    switch (action.type) {
        case assessmentSummaryConstants.REQUEST_ASSESSMENT_REPORT:
            return {
                AssessmentReportLoading: true,
                data: '',
                error: false
            };
        case assessmentSummaryConstants.RECEIVE_ASSESSMENT_REPORT:
            return {
                AssessmentReportLoading: false,
                data: action.getAssessementReport,
                error: false
            };
        case assessmentSummaryConstants.ASSESSMENT_REPORT_ERROR:
            return {
                AssessmentReportLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/assessmentSummary/getAssessmentReport.reducer.js